import React from 'react';
import './css/CustomModal.css';

// This component displays a custom modal with a title, message, and confirm/cancel buttons.
function CustomModal({ isOpen, onClose, title, message, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <h2></h2><br></br>
        <h2 className="custom-modal-title">{title}</h2>
        <p className="custom-modal-message">{message}</p>
        <div className="custom-modal-actions">
          <button className='modal-button confirm-button' onClick={() => {
            console.log('Modal OK clicked');
            onConfirm && onConfirm();
          }}>
            OK
          </button>
          <button className="modal-button cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomModal;